import { ComponentPropsWithoutRef, forwardRef } from 'react'

import * as PopoverPrimitive from '@radix-ui/react-popover'
import { styled } from 'styled-components'

import { surfaceBright, outline } from 'core/styles'

export const Popover = PopoverPrimitive.Root
export const PopoverAnchor = PopoverPrimitive.Anchor
export const PopoverTrigger = PopoverPrimitive.Trigger

export const PopoverContent = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>((props, ref) => (
  <PopoverPrimitive.Portal>
    <StyledContent ref={ref} {...props} />
  </PopoverPrimitive.Portal>
))

PopoverContent.displayName = 'PopoverContent'

export const PopoverClose = PopoverPrimitive.Close

const StyledContent = styled(PopoverPrimitive.Content)`
  z-index: 10;
  border: 1px solid ${outline};
  border-radius: 8px;
  background-color: ${surfaceBright};
  padding: 16px;
`
